import { Directive } from '@angular/core'

interface SimpleStatContext {
    $implicit: number
}

@Directive({
    selector: 'ng-template[stat-tmp]',
    standalone: true,
})
export class SimpleStatTemplateDirective<T> {
    value: number = 0

    static ngTemplateContextGuard<TContext>(
        dir: SimpleStatTemplateDirective<TContext>,
        ctx: unknown
    ): ctx is SimpleStatContext {
        return true
    }
}
